import blobStream from 'blob-stream';
import PDFDocument from 'pdfkit';
import SVGToPDFKit from 'svg-to-pdfkit';
import {
  pdfMIMEType,
} from './exportsPanel/Utils';

type ISynchronousSVGStringGetter<Input> = (input: Input) => string;

const getPNGDataURLGetter =
  <Input>(getSVGString: ISynchronousSVGStringGetter<Input>) =>
    (inputData: Input): Promise<Blob> =>
      new Promise((resolve, reject) => {
        try {
          const svgString = getSVGString(inputData);
          const pdfDocument = new PDFDocument();

          // Set up stream:
          const stream = pdfDocument.pipe(blobStream());
          stream.on('finish', () => {
            const blob = stream.toBlob(pdfMIMEType);
            resolve(blob);
          });

          SVGToPDFKit(pdfDocument, svgString, 0, 0);
          pdfDocument.end();

        } catch (e) {
          reject(e);
        }
      });

export default getPNGDataURLGetter;
